<template>
    <v-card>
        <v-card-title>Saved Courses</v-card-title>
        <template v-if="!loading">
            <v-card-text> 
                <template v-if="courses && courses.data && courses.data.length">
                    <CourseCard :key="j.id" v-for="j in courses.data" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                    @refresh="refresh()"
                    @toggleComponentLogin="toggleComponentLogin($event)">
                    </CourseCard>
                    <br/><br/>
                    <Pagination :isJSON="true" v-if="courses && courses.links" :links="courses.links"></Pagination>
                </template>
                <template v-else>
                    No saved courses.
                </template>
            </v-card-text>  
        </template>
        <template v-if="loading">
            <v-card-text class="text-center justify-center" min-height="300">    
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            </v-card-text>
        </template>
    </v-card>
</template>

<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import CourseCard from '@/Shared/CourseCard'
  import axios from 'axios'
  import Pagination from '@/Shared/Pagination'


  export default {
    props: {
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      CourseCard,
      Pagination
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            expandSearch: false,
            loading:false,
            courses:null,
            currentPage:1
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.getFavorites({});
    },
    methods: {
        refresh() {
            this.loading=true;
            var vm=this;
            let data = {
                course_pag: this.currentPage
            }
            axios.get(this.baseurl+'/favorite/courses',{ params:data }).then(function (result){
                console.log('got favorite courses',result)
                vm.courses = result.data;
                
                vm.currentPage = data.course_page;
                vm.loading=false;
            })
            .catch(function (e) { console.log('error',e)}) 
        },
        getFavorites(data) {
            this.loading=true;
            var vm=this;
            if (!data || !data.label)
                data.course_page = 1;
            else if (data.label == 'Next &raquo;')
                data.course_page = this.currentPage+1;
            else if (parseInt(data.label))
                data.course_page = data.label;
            else
                data.course_page = this.currentPage-1;

            axios.get(this.baseurl+'/favorite/courses',{ params:data }).then(function (result){
                console.log('got favorite courses',result)
                vm.courses = result.data;
                
                vm.currentPage = data.course_page;
                vm.loading=false;
            })
            .catch(function (e) { console.log('error',e)}) 
        },
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
    },
  }
  </script>